import { Link } from "react-router-dom";
import { MenuItem } from "react-pro-sidebar";
import { Typography } from "@mui/material";

const Item = ({ title, to, icon, selected, setSelected }) => {
  const isActive = selected === title;
  return (
    <Link to={to} style={{ textDecoration: "none", color: "inherit" }}>
      <MenuItem
        active={isActive}
        style={{
          color: isActive ? "var(--red)" : "var(--color-grey-light)",
          background: isActive ? "var(--color-red-10)" : "var(--dark-purple)",
        }}
        onClick={() => setSelected(title)}
        icon={icon}
      >
        <Typography sx={{ fontWeight: isActive ? 800 : 0 }}>{title}</Typography>
      </MenuItem>
    </Link>
  );
};

export default Item;
